import React from "react";
import { PlanProvider } from '@/contexts/PlanContext';
import Header from "@/components/join/Header";
import HeroSection from "@/components/join/HeroSection";
import TrustIndicators from "@/components/join/TrustIndicators";
import ProblemSection from "@/components/join/ProblemSection";
import SolutionSection from "@/components/join/SolutionSection";
import HowItWorks from "@/components/join/HowItWorks";
import DashboardPreview from "@/components/join/DashboardPreview";
import PricingSection from "@/components/join/PricingSection";
import UseCasesSection from "@/components/join/UseCasesSection";
import SocialProofSection from "@/components/join/SocialProofSection";
import FaqSection from "@/components/join/FaqSection";
import CtaSection from "@/components/join/CtaSection";
import ContactSalesSection from "@/components/join/ContactSalesSection";
import TestedProductsSection from "@/components/join/TestedProductsSection";
import Footer from "@/components/join/Footer";

import '@/pages/join/Join.css';

export default function JoinComponent() {
  // Simplified to ensure rendering works properly
  React.useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach((element) => {
      observer.observe(element);
    });

    return () => {
      animatedElements.forEach((element) => {
        observer.unobserve(element);
      });
    };
  }, []);

  return (
    <PlanProvider>
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <HeroSection />
          <TrustIndicators />
          <ProblemSection />
          <SolutionSection />
          <HowItWorks />
          <DashboardPreview />
          <PricingSection />
          <UseCasesSection />
          <SocialProofSection />
          <FaqSection />
          <CtaSection />
          <ContactSalesSection />
          <TestedProductsSection />
        </main>
        <Footer />
      </div>
    </PlanProvider>
  );
};
